import _ from 'lodash'
import { firestore } from '../firebase'

export const affLookup = []

export const affTable = []

export const affIdHashedLookup = {}

export const zeroBounceList = [
  'valid',
  'invalid',
  'catch-all',
  'spamtrap',
  'abuse',
  'do_not_mail',
  'unknown'
]

export const zeroBounceSubList = [
  'alias_address',
  'antispam_system',
  'does_not_accept_mail',
  'exception_occurred',
  'failed_smtp_connection',
  'failed_syntax_check',
  'forcible_disconnect',
  'global_suppression',
  'greylisted',
  'leading_period_removed',
  'mail_server_did_not_respond',
  'mail_server_temporary_error',
  'mailbox_quota_exceeded',
  'mailbox_not_found',
  'no_dns_entries',
  'possible_trap',
  'possible_typo',
  'role_based',
  'role_based_catch_all',
  'timeout_exceeded',
  'unroutable_ip_address',
  'disposable',
  'toxic',
  'alternate'
]

export const sourceNameLookup = leadData => {
  console.log('sourceNameLookup', { leadData })

  const source = getLeadSource(leadData)
  console.log('sourceNameLookup', { source })
  return source?.name || `n/a (${leadData.affId})`
}

// find a lead source by affId (mandatory) and maybe other (optional) criteria
export const getLeadSource = leadData => {
  // console.log('getLeadSource', { leadData })

  // to normalize so that we can filter and sort properly
  const allBlankKeys = Object.keys(leadData).reduce((o, k) => ({ ...o, [k]: '*' }), {})

  const sources = affLookup
    // normalize, clean
    .map(x => ({ ...allBlankKeys, ...x, created_at: undefined, updated_at: undefined, affIdHashed: undefined }))
    // filter by all keys (* or specific value)
    .filter(x => Object
      .entries(leadData)
      .reduce((include, [key, val]) => include && (!x[key] || x[key] === '*' || val === x[key]), true))

  if (!sources?.length) return

  // order by most specific match
  const sortedSources = _.orderBy(sources, Object.keys(allBlankKeys), Object.keys(allBlankKeys).fill('desc'))

  return Object.entries(sortedSources[0]).reduce((cleaned, [k, v]) => ({ ...cleaned, ...v !== '*' && { [k]: v } }), {})
}

// build lookup from firestore on initial page load
(async () => {

  const ret = await firestore.collection('leadSources').get()

  if (ret.empty) return

  ret.docs.forEach(d => {
    const data = d.data()
    affLookup.push(data)
    affTable.push(data.affId)
    affIdHashedLookup[data.affId] = data.affIdHashed
  })
})();